/**
 * @import external modules
 */

import * as React from 'react';
import { pure } from 'recompose';

// component
const Component: React.FunctionComponent<any> = (
    props: InterfaceInfosDelayed<any>,
): JSX.Element => {
    const {} = props;

    return (
        <div className="with-3-columns">
            <div className="content-li">
                <div className="items-content-li svg-class">
                    <div className="svg-delayed">
                        <span>
                            <span>
                                <svg
                                    width="39"
                                    height="30"
                                    viewBox="0 0 39 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M37.3758 7.0334C37.2018 7.0334 37.0278 7.05305 36.8537 7.11198L34.8815 7.66208L32.8319 2.61297C32.2712 1.15914 30.5503 0 29.0228 0H9.91919C8.39167 0 6.69013 1.15914 6.11006 2.59332L4.06049 7.64244L2.12692 7.09234C1.9529 7.05305 1.77888 7.01375 1.60486 7.01375C0.676748 7.01375 0 7.74067 0 8.72299V9.90177C0 11.0609 0.928111 12.0039 2.06891 12.0039H2.30094L1.97224 12.8291C1.43084 14.165 1.00545 16.4047 1.00545 17.8585V27.8978C1.00545 29.057 1.93356 30 3.07437 30H5.78136C6.92216 30 7.85027 29.057 7.85027 27.8978V25.3831H31.1304V27.8978C31.1304 29.057 32.0585 30 33.1993 30H35.9063C37.0471 30 37.9752 29.057 37.9752 27.8978V17.8585C37.9752 16.4244 37.5305 14.165 37.0084 12.8291L36.6797 12.0039H36.9311C38.0719 12.0039 39 11.0609 39 9.90177V8.72299C38.9807 7.74067 38.3039 7.0334 37.3758 7.0334ZM5.54933 10.8841L8.64303 3.24165C8.99108 2.37721 10.0159 1.68959 10.9246 1.68959H28.0174C28.9261 1.68959 29.9509 2.39686 30.299 3.24165L33.3927 10.8841C33.7407 11.7485 33.2766 12.4361 32.3679 12.4361H6.57412C5.66534 12.4361 5.20129 11.7485 5.54933 10.8841ZM12.4522 20.5501C12.4522 21.0216 12.0848 21.3949 11.6207 21.3949H5.74269C5.27863 21.3949 4.91125 21.0216 4.91125 20.5501V17.7014C4.91125 17.2299 5.27863 16.8566 5.74269 16.8566H11.6207C12.0848 16.8566 12.4522 17.2299 12.4522 17.7014V20.5501ZM33.9727 20.5501C33.9727 21.0216 33.6054 21.3949 33.1413 21.3949H27.2633C26.7992 21.3949 26.4318 21.0216 26.4318 20.5501V17.7014C26.4318 17.2299 26.7992 16.8566 27.2633 16.8566H33.1413C33.6054 16.8566 33.9727 17.2299 33.9727 17.7014V20.5501Z"
                                        fill="white"
                                    />
                                </svg>
                            </span>
                            <span className="separator" />
                            <span className="svg-stats" id="svg-stats-categ">
                                0
                            </span>
                        </span>
                    </div>
                    <div className="infos-delayed-text">
                        <span>Classe Cyclope</span>
                    </div>
                </div>
            </div>
            <div className="content-li">
                <div className="items-content-li ">
                    <div className="svg-delayed">
                        <span>
                            <span>
                                <svg
                                    width="26"
                                    height="34"
                                    viewBox="0 0 26 34"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M26 2.98828V0H0V2.98828C0 4.28984 0.833333 5.39219 2 5.80391V28.1961C0.833333 28.6078 0 29.7102 0 31.0117V34H26V31.0117C26 29.7102 25.1667 28.6078 24 28.1961V5.80391C25.1667 5.39219 26 4.28984 26 2.98828ZM20 28.0234V24.1852C20 21.8477 18.8333 19.6828 16.88 18.3812L14.8 17L16.88 15.6187C18.8333 14.3238 20 12.1523 20 9.81484V5.97656H22V28.0234H20ZM6 5.97656V9.81484C6 12.1523 7.16667 14.3172 9.12 15.6187L11.2 17L9.12 18.3812C7.16667 19.6762 6 21.8477 6 24.1852V28.0234H4V5.97656H6Z"
                                        fill="#4DA1FF"
                                    />
                                </svg>
                            </span>
                            <span className="separator" />
                            <span className="svg-stats" id="svg-stats-temps">
                                0
                            </span>
                        </span>
                    </div>
                    <div className="infos-delayed-text">
                        <span>Temps d'exécution</span>
                    </div>
                </div>
            </div>
            <div className="content-li">
                <div className="items-content-li ">
                    <div className="svg-delayed">
                        <span>
                            <span>
                                <svg
                                    width="26"
                                    height="34"
                                    viewBox="0 0 29 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect
                                        width="7"
                                        height="32"
                                        fill="#4DA1FF"
                                    />
                                    <rect
                                        x="11"
                                        y="9"
                                        width="7"
                                        height="23"
                                        fill="#4DA1FF"
                                    />
                                    <rect
                                        x="22"
                                        y="20"
                                        width="7"
                                        height="12"
                                        fill="#4DA1FF"
                                    />
                                </svg>
                            </span>
                            <span className="separator" />
                            <span
                                className="svg-stats"
                                id="svg-stats-confidence">
                                0
                            </span>
                        </span>
                    </div>
                    <div className="infos-delayed-text">
                        <span>Taux de confiance</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

// interface
export interface InterfaceInfosDelayed<T> {
    items?: T;
}

/**
 * DefaultProps values
 */
Component.defaultProps = {};

export default pure(Component);



// WEBPACK FOOTER //
// ./src/apps/components/@widgets/infos-delayed/component.tsx